import { errors as lang_error } from '@/lang/ja_JP'

export default {
  name: 'handleErrors',
  methods: {
    /**
     *
     * @param string field
     * @param string scope
     * @returns {string}
     */
    getInputType (field) {
      if (
        this.errors.has(field) ||
        // TODO FormHeader子コンポーネントから呼ばれた場合、呼び方が統一されない
        //  クライアントエラーだとthis.errorsに入っている
        //  サーバーエラーを埋め込みなおしていると、this.$parent.$parent.errorsに入っている
        (this.$parent.$parent && this.$parent.$parent.errors.has(field))
      ) {
        return 'is-danger'
      } else {
        const $field = this.$validator.fields.find({ name: field })
        // TODO querySelectorを使わないもっといい方法はないか
        if ($field && $field.value) {
          const $input = $field.el.querySelector(`[name="${field}"]:valid`) || {}
          if ((typeof $input.matches === 'function' && $input.matches(':valid')) ||
            (typeof $input.msMatchesSelector === 'function' && $input.msMatchesSelector(':valid'))) {
            return 'is-success'
          }
        }
        return ''
      }
    },
    /**
     *
     * @param field
     * @param errors
     * @returns {string}
     */
    getInputMessage (field) {
      if (this.errors.has(field)) {
        return this.errors.first(field)
      } else if (this.$parent.$parent && this.$parent.$parent.errors.has(field)) {
        // TODO FormHeader子コンポーネントから呼ばれた場合、呼び方が統一されない
        //  クライアントエラーだとthis.errorsに入っている
        //  サーバーエラーを埋め込みなおしていると、this.$parent.$parent.errorsに入っている
        return this.$parent.$parent.errors.first(field)
      }
      return ''
    },
    /**
     *
     * @param error
     * @returns array メッセージ
     */
    fetchErrorMessages (error) {
      // JSエラー、サーバー停止など
      if (!error.response) {
        return this._getClientErrors(error)
      }

      let status = error.response && error.response.status
      let data = error.response && error.response.data

      // システムエラー
      if (status === 500) {
        return this._getServerErrors(data)
      }

      // バリデーションエラー
      if (status === 422) {
        return this._getValidationErrors(data)
      }

      // その他アプリエラー
      if (data.data) {
        return this._getAppErrors(data)
      }

      // その他エラー
      return [data.message]
    },
    isApiError (response) {
      return !response.data || !response.data.success
    },
    isTimeoutError (error) {
      return error.code === 'ECONNABORTED'
    },
    isNetworkError (error) {
      const message = error.message
      return (message && message.toLowerCase().indexOf('network error') === 0)
    },
    /**
     *
     * @param error
     * @returns {*}
     * @private
     */
    _getClientErrors (error) {
      // APIキャンセルは除外
      if (error.message === lang_error.apiCanceled) {
        return []
      }
      // タイムアウトエラー
      if (this.isTimeoutError(error)) {
        return [lang_error.timeout]
      }
      // ネットワークエラー
      if (this.isNetworkError(error)) {
        return [lang_error.networkError]
      }
    },
    _getServerErrors ({ data }) {
      return [
        'システムエラーが発生しました。管理者にお問い合わせください。',
        data.message
      ]
    },
    _getValidationErrors ({ data }) {
      data.errors.application = data.errors.application || {}

      this._setValidationErrors(data.errors.application, 'application')
      delete data.errors.application
      this._setValidationErrors(data.errors, null)

      return [lang_error.validError]
    },
    /**
     *
     * @param data
     * @param scope
     * @private
     */
    _setValidationErrors (data, scope) {
      for (let field in data) {
        for (let rule in data[field]) {
          this.errors.add({
            scope,
            field,
            rule,
            msg: data[field][rule]
          })
        }
      }
    },
    _getAppErrors ({ data }) {
      let key, type

      if ('errors' in data) {
        let messages = []

        for (key in data.errors) {
          for (type in data.errors[key]) {
            messages.push(data.errors[key][type], key)
          }
        }

        return messages
      }

      if ('data' in data && 'message' in data.data) {
        return [data.data.message] // TODO どういう時にこの階層にmessageが入るか不明
      } else {
        return [data.message]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/handleErrors.js